export const ADMIN = {
  loginCard: "admin-login-card",
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",

  dashboard: "admin-dashboard",
  logoutButton: "admin-logout-button",
  statTotal: "admin-stat-total",
  stat24h: "admin-stat-24h",
  stat7d: "admin-stat-7d",
  statRate: "admin-stat-rate",

  leadsTable: "admin-leads-table",
  leadRow: (id) => `admin-lead-row-${id}`,
  searchInput: "admin-search-input",
  refreshButton: "admin-refresh-button",
  exportButton: "admin-export-button",
  leadExpand: (id) => `admin-lead-expand-${id}`,
  leadDetails: (id) => `admin-lead-details-${id}`,
  emptyState: "admin-empty-state",
};
